import { TemplateElement, html, defineElement, optionalAttribute, when } from '@webtides/element-js';
import style from './e-banking-button-bar.css';
import '../../../button/button.js';

/**
 * @property {LinkProperties[]} links - Links
 * @property {string} subline
 */
export default class ButtonBar extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            links: [],
            subline: '',
        };
    }

    template() {
        return html`
            <div class="flex flex-col items-center w-full">
                <div class="flex flex-wrap justify-center gap-fix-s w-full">
                    ${this.links.map(
                        (link, index) => html`
                            <mb-button
                                ref="buttons[]"
                                href="${link.url}"
                                variant="${link.variant || index === 0 ? 'primary' : 'secondary'}"
                                ${optionalAttribute(
                                    link.type === 'external' || link.type === 'download',
                                    'target',
                                    '_blank',
                                )}
                                class="w-full"
                                size="sm"
                                element="button bar"
                            >
                                ${link.text}
                            </mb-button>
                        `,
                    )}
                </div>
                ${when(
                    this.subline,
                    html` <div class="mt-16 text-green-medium text-base hyphens-auto">${this.subline}</div> `,
                )}
            </div>
        `;
    }
}

defineElement('mb-e-banking-button-bar', ButtonBar);
